















import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import FormInput from '@/components/atoms/FormInput.vue'
import ListItem from '@/components/molecules/ListItem.vue'

export default Vue.extend({
  name: 'PasswordRegistration',
  components: {
    PageTitle,
    ButtonWrap,
    RoundButton,
    ListItem,
    FormInput
  },
  methods: {
    onChange(value: string) {}
  }
})
